import { Link, useNavigate } from "react-router-dom";
import { HARDCODED_PRODUCTKEY } from "../../common/constant";

const CreditAlert = ({ message, buttonLabel = "Add Credits" }) => {
  const navigate = useNavigate();
  return (
    <div className="alert alert-warning text-center">
      <h5>Your credits are low.</h5>
      <p>{message || "Please add more credits to access this product."}</p>
      <a
        onClick={() =>
          (window.location.href = `${window.baseUrl}/subscription?productKey=${HARDCODED_PRODUCTKEY}`)
        }
        className="btn btn-outline-dark btn-sm mt-2"
        rel="noopener noreferrer"
        style={{ cursor: "pointer" }}
      >
        {buttonLabel}
      </a>
    </div>
  );
};

export default CreditAlert;
